export default __webpack_public_path__ + "static/media/OurBloggers2.c77be0fd.png";